import { useEffect, useState } from 'react';

export const useAfterRender = (callback?: () => void) => {
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    if (isRendered) return;

    setIsRendered(true);
    callback?.();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRendered]);

  return { isRendered };
};
